import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import { objectToSnakeCase } from '../utils'
import axios from 'axios'
import Auth from '../auth'

export const ADMIN_ENDPOINT = `${API_BASE}admin/`

export default class AdminAPI {
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `UserAPI`.
   *
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new AdminAPI(cls)
  }

  list({ pagination, filters }) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({ key: 'page' }),
      pageSize: ApiFilter.create({ key: 'page_size' }),

      // Sorting
      ordering: ApiFilter.create({ key: 'ordering' }),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, { ...pagination, ...filters }),
    }

    const promise = axios
      .get(`${ADMIN_ENDPOINT}`, options)
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'List Admin API error',
          rethrowErrors: true,
        }),
      )
    return promise
  }

  async update(admin, fields = [], excludeFields = []) {
    this.cls.checkIsInstance(admin, 'The `admin` argument')

    const url = `${ADMIN_ENDPOINT}${admin.id}/`
    let data = this.cls.toAPI(admin, fields, excludeFields)
    const options = {
      headers: await Auth.getHeaders(),
    }
    return axios
      .patch(url, data, options)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Update Admin API error', rethrowErrors: true }))
  }

  /**
   * Get Admin via the API
   *
   * @param {string} idUser - ID of the admin to retrieve.
   *
   * @returns {Promise} - Promise wrapping the admin data in API response.
   */
  async retrieve(adminId) {
    const url = `${ADMIN_ENDPOINT}${adminId}/`
    const options = {
      headers: await Auth.getHeaders(),
    }
    return axios
      .get(url, options)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Retrieve Admin API error' }))
  }
}
